import React, { Component } from 'react';
import { Icon } from "semantic-ui-react";
import moment from "moment/moment";
import { adpLink } from "../../../constants";
export default class Collections extends Component {

    getSortedArray = (arr) => {
        return arr.sort((a, b) => {
            return new Date(a.dateKey) - new Date(b.dateKey);
        })
    }

    render() {
        const { doctorName, startDate, contractType, numberOfDaysWorked, dentistWorkTimeType, mtdBillable,
            earnings, dailyRatePay, patientVisits, formatCurrency, unFormatCurrency, financialNotes,
            productionPayDetails, payRateOverBase, payChecks, prodAdjWo, productionPrice, collectionTotal, collectionPay } = this.props;

        const bCare = unFormatCurrency(mtdBillable)
        const procBasedPay = bCare * (payRateOverBase / 100);
        const percentageOfBillable = (procBasedPay / bCare) * 100;
        const basePay = numberOfDaysWorked * dailyRatePay;
        return (
            <div>
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>{doctorName}</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Pay Month</p>
                                        <p>{moment(startDate).add(1, 'months').format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Work Month</p>
                                        <p>{moment(startDate).format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Work Month Collections</p>
                                        <p>{formatCurrency(collectionTotal)}</p>
                                    </li>
                                    <li>
                                        <p>Worked Days</p>
                                        <p>{numberOfDaysWorked}</p>
                                    </li>
                                    <li>
                                        <p>Monthly Base Pay</p>
                                        <p>{formatCurrency(basePay)}</p>
                                    </li>
                                    <li>
                                        <p>Monthly Collections Pay</p>
                                        <p>{formatCurrency(collectionPay)}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits</p>
                                        <p>{patientVisits}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits/ Day </p>
                                        <p>{(patientVisits / numberOfDaysWorked).toFixed(0)}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Contract Details</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Contract Type</p>
                                        <p>Collections</p>
                                    </li>
                                    <li>
                                        <p>Percentage of Billable Collections</p>
                                        <p>{(percentageOfBillable).toFixed(0)}</p>
                                    </li>
                                    <li>
                                        <p>Day Rate</p>
                                        <p>{formatCurrency(dailyRatePay)}</p>
                                    </li>
                                    <li>
                                        <p>Work Status</p>
                                        <p>{dentistWorkTimeType}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                {payChecks && payChecks.depositDates && payChecks.depositDates.map((date, i) =>
                                    <React.Fragment>
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <h5 className="mr10">{i + 1}{i === 0 ? 'st' : 'nd'} Friday Gross Pay Pre-Tax</h5>
                                            <strong className="secondaryColor">{date}</strong>
                                        </div>
                                        <table className="table table-striped table-hover table-sm mt-0 mb-0">
                                            <thead>
                                                <tr>
                                                    <th>OFFICE</th>
                                                    <th className="text-right">EARNINGS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.entries(payChecks.practice).map(([practice, checks]) => <tr>
                                                    <td>{this.props.getPracticeName(practice)}</td>
                                                    <td className="text-right">{formatCurrency(checks.splits[i])}</td>
                                                </tr>)}
                                                <tr>
                                                    <td><strong>Total</strong></td>
                                                    <td className="text-right"><strong>{formatCurrency(Object.values(payChecks.practice).reduce((total, curr) => (total + curr.splits[i]), 0))}
                                                    </strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Accessing Your Pay Stub</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Link to ADP</p>
                                        <p><a href={adpLink} target={"_blank"}><Icon name='external alternate' className="primaryColor" /></a></p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="table-responsive mb20">
                    <h5>Financial Notes</h5>
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th><div>NOTES TYPE</div></th>
                                <th><div>DATE</div></th>
                                <th><div>TITLE</div></th>
                                <th><div>PRACTICE</div></th>
                                <th><div>PROVIDER</div></th>
                                <th><div>DESCRIPTION</div></th>
                                <th><div>AMOUNT</div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {financialNotes}
                            {financialNotes.length < 1 && (<tr key={`financialNoteRowTotal`}>
                                <td colSpan={7}><strong>No records found</strong></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className="table-responsive">
                    <h5>Pay Details</h5>
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th><div>SERVICE DATE</div></th>
                                <th><div>PRACTICE</div></th>
                                <th><div>COLLECTIONS</div></th>
                                <th><div>FINANCIAL NOTES</div></th>
                                <th><div>DAILY PAY</div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getSortedArray(productionPayDetails)}
                            {productionPayDetails.length < 1 && (<tr key={`productionPayDetailsRowTotal`}>
                                <td colSpan={5}><strong>No records found</strong></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}